function deferFilterjQuery() {
    if (window.jQuery) {
        var $ = window.jQuery;
        $(function(){

          // [ALL YOUR EXISTING PT CODE STAYS HERE - unchanged]
          // ... pt_on_load(), mobile toggle, accordion, search, dropdowns, apply button, ajax ...

          // ── Offcuts Mobile Drawer ──
$('.pt-drawer, .pt-drawer-overlay').remove();

var drawerHTML =
  '<div class="pt-drawer-overlay"></div>' +
  '<div class="pt-drawer" aria-hidden="true">' +
    '<div class="pt-drawer-header">' +
      '<span>Filter</span>' +
      '<button class="pt-drawer-close" aria-label="Close filters">&#x2715;</button>' +
    '</div>' +
    '<div class="pt-drawer-body"></div>' +
    '<div class="pt-drawer-footer">' +
      '<a class="pt-drawer-clear-all" href="' + window.location.pathname.split('/').slice(0,3).join('/') + '">Clear All</a>' +
      '<button class="pt-drawer-apply">View Results</button>' +
    '</div>' +
  '</div>';

$('body').append(drawerHTML);

// Sort pill
if ($('.pt-mobile-header').length && !$('.pt-mobile-sort').length) {
  var $nativeSort = $('.collection-sorting select');
  if ($nativeSort.length) {
    var currentSortLabel = $('.collection-sorting .selected-text strong').text().trim() || 'Sort';
    var $clonedSelect = $nativeSort.clone();
    $clonedSelect.on('change', function() {
      $nativeSort.val($(this).val()).trigger('change');
    });
    var $sortPill = $(
      '<div class="pt-mobile-sort">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M7 12h10M11 18h2"/></svg>' +
      '<span>' + currentSortLabel + '</span>' +
      '</div>'
    );
    $sortPill.append($clonedSelect);
    $('.pt-mobile-header').first().append($sortPill);
  }
}

function ptDrawerOpen() {
  $('.pt-drawer-body').empty();
  $('.filter-menu').first().find('.filter-group').not('.filter-group-sort-orders, .refine-header').each(function() {
    $('.pt-drawer-body').append($(this).clone(false));
  });
  $('.pt-drawer').data('pending-url', window.location.href);
  $('.pt-drawer').addClass('pt-drawer-open').attr('aria-hidden', 'false');
  $('.pt-drawer-overlay').addClass('pt-drawer-open');
  $('body').css('overflow', 'hidden');
}

function ptDrawerClose() {
  $('.pt-drawer').removeClass('pt-drawer-open').attr('aria-hidden', 'true');
  $('.pt-drawer-overlay').removeClass('pt-drawer-open');
  $('.pt-drawer-body .filter-group').removeClass('pt-group-expanded');
  $('.pt-drawer').removeData('pending-url');
  $('body').css('overflow', '');
}

function ptDrawerFetch(url, keepExpanded) {
  var $expanded = [];
  if (keepExpanded) {
    $('.pt-drawer-body .filter-group.pt-group-expanded').each(function() {
      $expanded.push($(this).find('h4').text().trim());
    });
  }
  $.get(url, function(data) {
    var $newMenu = $(data).find('.filter-menu').first();
    if ($newMenu.length) {
      $('.pt-drawer-body').empty();
      $newMenu.find('.filter-group').not('.filter-group-sort-orders, .refine-header').each(function() {
        var $clone = $(this).clone(false);
        // Re-expand previously open sections
        var title = $clone.find('h4').text().trim();
        if ($expanded.indexOf(title) > -1) {
          $clone.addClass('pt-group-expanded');
        }
        $('.pt-drawer-body').append($clone);
      });
      var newClear = $newMenu.find('.refine-header .filter-clear').attr('href');
      if (newClear) $('.pt-drawer-clear-all').attr('href', newClear);
    }
  });
}

// Open
$(document).off('click.ptdrawer').on('click.ptdrawer', '.pt-drawer-toggle', function(e) {
  e.preventDefault();
  ptDrawerOpen();
});

// Close
// X button — discard and close
$(document).off('click.ptdrawerclose').on('click.ptdrawerclose', '.pt-drawer-close', function() {
  ptDrawerClose();
});

// Overlay tap — apply and navigate (same as View Results)
$(document).off('click.ptdraweroverlay').on('click.ptdraweroverlay', '.pt-drawer-overlay', function() {
  var url = $('.pt-drawer').data('pending-url');
  ptDrawerClose();
  if (url && url !== window.location.href) {
    window.location = url;
  }
});


// Accordion inside drawer
$(document).off('click.ptdraweraccordion').on('click.ptdraweraccordion', '.pt-drawer-body .filter-group h4', function(e) {
  e.stopPropagation();
  e.stopImmediatePropagation(); // prevent PT's own accordion handler firing
  $(this).closest('.filter-group').toggleClass('pt-group-expanded');
});


// Filter link clicks — stage, don't navigate
$(document).off('click.ptdrawerfilter').on('click.ptdrawerfilter', '.pt-drawer-body a', function(e) {
  e.preventDefault();
  var url = $(this).attr('href');
  if (!url || url === '#') return;
  $('.pt-drawer').data('pending-url', url);
  ptDrawerFetch(url, true);
});

// Apply
$(document).off('click.ptdrawerapply').on('click.ptdrawerapply', '.pt-drawer-apply', function() {
  var url = $('.pt-drawer').data('pending-url');
  ptDrawerClose();
  if (url && url !== window.location.href) {
    window.location = url;
  }
});

// Clear all
$(document).off('click.ptdrawerclear').on('click.ptdrawerclear', '.pt-drawer-clear-all', function(e) {
  e.preventDefault();
  var url = $(this).attr('href');
  $('.pt-drawer').data('pending-url', url);
  ptDrawerFetch(url, false);
});

// Re-bind PT accordion for main sidebar
$(document).off('click.ptaccordion').on('click.ptaccordion', '.filter-menu .filter-group h4', function(e) {
  $(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
  e.preventDefault();
});
// ── End Offcuts Mobile Drawer ──


        });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
